import {z} from 'zod';
import { Address } from './Address';

export const Store = z.object({
  id: z.coerce.number(),
  addressLine1: z.string().nullable(),
  addressLine2: z.string().nullable(),
  salutationForm: z.string().nullable(),
  organisationName: z.string().nullable(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  middleName: z.string().nullable(),
  coName: z.string().nullable(),
  fullName: z.string().nullable(),
  companyNumber: z.string().nullable(),
  companyVatNumber: z.string().nullable(),
  zipCode: z.string().nullable(),
  zusaNumber: z.string().nullable(),
  city: z.string().nullable(),


  latitude: z.coerce.number(),
  longitude: z.coerce.number(),
  distance: z.coerce.number().default(0),

  phone: z.string().nullable(),
  email: z.string().nullable(),

  additionalUrl: z.string().nullable(),

  crmAddress: Address,
});

export type Store = z.infer<typeof Store>;
